var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduler({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1765865684568,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1227,
    "data-spm-anchor-id": "a313x.manage_type_mylikes.0.i6.50713a81tGCO6Y",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M858.406033 449.085088l-252.686023 0 169.576163 296.708656c57.701167-64.593134 89.159646-146.494469 89.159646-233.794767C864.455819 491.524666 862.409207 470.397487 858.406033 449.085088z",
    "p-id": 1228
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M846.122265 400.872017c-33.972742-102.280478-113.547079-184.088692-215.270878-220.571604l-126.481669 219.083717L846.122265 400.872017z",
    "p-id": 1229
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M582.918701 166.804027c-23.362081-4.840238-47.093575-7.258311-70.920236-7.258311-83.854826 0-163.989935 29.596062-227.740888 83.947947l126.293381 218.806401L582.918701 166.804027z",
    "p-id": 1230
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.706897 278.301424c-57.798381 64.494896-89.163739 146.400325-89.163739 233.697553 0 20.47738 1.956561 41.60149 5.956665 62.916958l252.779144 0.093121L248.706897 278.301424z",
    "p-id": 1231
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.786661 623.219057c33.968649 102.284571 113.546056 183.999664 215.363999 220.481554l126.481669-219.085764L177.786661 623.219057z",
    "p-id": 1232
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M440.989201 857.196996c23.452131 4.838192 47.183626 7.258311 71.010287 7.258311 83.857896 0 163.896814-29.689183 227.744981-83.853803l-126.391618-218.900545L440.989201 857.196996z",
    "p-id": 1233
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduler);
export default __webpack_public_path__ + "static/media/scheduler.e342faea151e493a3457a241e85a713d.svg";
export { ForwardRef as ReactComponent };